import React, { ElementType, ReactChild, ReactElement } from 'react'
import LogFilterDropdown from 'ui/CommonLogComponents/LogFilterDropdown'
import { QueriesFilterMenuType } from '../FiltersContainer'
import { ExternalIcon } from 'components/Dashboard/CommonComponents/ExternalSvgIcon'
import { useAppSelector } from 'store/hooks'
import { useHideTooltipOnScroll } from 'utils/useHideTooltipOnScroll'
import { scrollingContainerRef } from 'components/Dashboard/DashboardScrollingContainer'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import { scrollingFiltersContainerRef } from 'ui/CommonLogComponents/FiltersScrollingContainer'

export const hideQueryFilterDropdown = {}

export default function QueryFilterDropdown({
  children,
  isDisabled,
  selectedValue,
  icon,
  externalIcon,
  type,
  testId,
  isLoading,
}: {
  children: ReactChild | ReactChild[]
  isDisabled?: boolean
  selectedValue: string
  icon?: ElementType
  externalIcon?: ExternalIcon
  type?: QueriesFilterMenuType
  testId?: string
  isLoading?: boolean
}): ReactElement | null {
  const isMobile = useBreakpointIndex() === 0
  const filterParameters = useAppSelector(s => s.activityLog.queryFilters)

  const { setShouldIgnoreHideOnScroll } = useHideTooltipOnScroll(
    { current: hideQueryFilterDropdown[type || ''] },
    isMobile ? scrollingFiltersContainerRef : scrollingContainerRef,
    isMobile,
  )

  return (
    <LogFilterDropdown
      ariaLabel={`${type} dropdown`}
      testId={testId || `${type}-queries-filters-dropdown`}
      value={selectedValue}
      isValueSelected={!!filterParameters[type || ''] && filterParameters[type || ''] !== 'all'}
      icon={icon}
      externalIcon={externalIcon}
      isDisabled={isDisabled}
      isLoading={isLoading}
      onShow={() => {
        setShouldIgnoreHideOnScroll(true)
        Object.values(hideQueryFilterDropdown)?.map(value => (value as () => void)?.())
      }}
      onShown={() => {
        setShouldIgnoreHideOnScroll(false)
      }}
      onCreate={instance => {
        if (type) {
          hideQueryFilterDropdown[type] = instance.hide
        }
      }}
      isLocation={type === QueriesFilterMenuType.LOCATIONS}
    >
      {children}
    </LogFilterDropdown>
  )
}
